export const mutations = {
  setCatagories: function (state, categories) {
    state.categories = [...categories];
  },

  setCatagory: function (state, category) {
    state.category = { ...category };
  },

  addCatagories: function (state, category) {
    state.categories.push(category);
  },

  updateCategory: function (state, category) {
    var index = [...state.categories].findIndex(
      (e) => e.cate_id == category.cate_id
    );
    if (index > -1) {
      state.categories[index] = category;
    }
  },

  removeCatagory: function (state, category) {
    var index = [...state.categories].findIndex(
      (e) => e.cate_id == category.cate_id
    );
    if (index > -1) {
      state.categories.splice(index, 1);
    }
  },
  setDocChecklist: function (state, doc) {
    state.docCheckList = doc ?? [];
  },
};
